module.exports = __webpack_public_path__ + "img/IMAGE 4.e4eadb84.png";